/**
 * Tech Hunk product page interactions — price sync, videos, badge position.
 */
(function () {
  var moneyFormat = '{{amount}}';

  function withDelimiters(number, precision, thousands, decimal) {
    precision = precision === undefined ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents) {
    var match = String(moneyFormat).match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return String(moneyFormat).replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function percentOff(compare, price) {
    if (!compare || compare <= price) return 0;
    return Math.round(((compare - price) * 100) / compare);
  }

  function initPriceBar(root) {
    var jsonEl = root.querySelector('[data-th-price-json]');
    if (!jsonEl) return;

    var variants;
    try {
      var parsed = JSON.parse(jsonEl.textContent);
      variants = parsed.variants;
      if (parsed.money_format) moneyFormat = parsed.money_format;
    } catch (e) {
      return;
    }

    var bar = root.querySelector('.th-pricebar');
    if (!bar) return;

    var priceEl = bar.querySelector('.th-price');
    var compareEl = bar.querySelector('.th-compare');
    var offEl = bar.querySelector('.th-off');

    function update(variantId) {
      var v = variants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      if (!v) return;

      if (priceEl) priceEl.textContent = money(v.price);

      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (compareEl) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        }
        if (offEl) {
          offEl.textContent = percentOff(v.compare_at_price, v.price) + '% OFF';
          offEl.style.display = '';
        }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (offEl) offEl.style.display = 'none';
      }
    }

    document.addEventListener(
      'change',
      function (e) {
        var input = e.target;
        if (!input || !input.name || input.name !== 'id') return;
        if (!root.contains(input.form || input)) return;
        update(input.value);
      },
      false
    );

    var mainProduct = document.querySelector('product-info.main-product-xc');
    var initial = mainProduct?.querySelector('input[name="id"]');
    if (initial) update(initial.value);
  }

  function initCloserVideos(container) {
    var modal = container.querySelector('[data-video-modal]');
    var box = container.querySelector('[data-video-box]');
    var close = container.querySelector('[data-video-close]');
    var scroll = container.querySelector('[data-video-scroll]');
    var progress = container.querySelector('[data-progress-bar]');

    if (!modal || !box) return;

    function openVideo(type, url) {
      box.innerHTML = '';
      if (type === 'youtube') {
        var id = url.match(/(?:youtu\.be\/|v=)([^&?]+)/)?.[1];
        if (!id) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        Object.assign(iframe.style, { position: 'absolute', inset: '0', width: '100%', height: '100%', border: '0' });
        box.style.position = 'relative';
        box.appendChild(iframe);
      } else {
        var video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        Object.assign(video.style, { width: '100%', height: '100%', objectFit: 'contain' });
        box.appendChild(video);
      }
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeVideo() {
      modal.classList.remove('active');
      box.innerHTML = '';
      document.body.style.overflow = '';
    }

    container.querySelectorAll('[data-video-trigger]').forEach(function (card) {
      card.addEventListener('click', function () {
        openVideo(this.dataset.videoType, this.dataset.videoUrl);
      });
    });

    if (close) close.addEventListener('click', closeVideo);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeVideo();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) closeVideo();
    });

    if (scroll && progress) {
      scroll.addEventListener('scroll', function () {
        var max = scroll.scrollWidth - scroll.clientWidth;
        var pct = max > 0 ? (scroll.scrollLeft / max) * 100 : 0;
        progress.style.width = Math.max(20, pct) + '%';
      });
    }
  }

  function initFallbackGallery(section) {
    var gallery = section.querySelector('[data-th-fallback-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[id^="ThFallbackMain-"]');
    var counter = gallery.querySelector('[data-th-fallback-counter]');
    var total = gallery.querySelectorAll('[data-th-fallback-thumb]').length;

    gallery.querySelectorAll('[data-th-fallback-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = this.dataset.src;
        gallery.querySelectorAll('[data-th-fallback-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');
        if (counter) counter.textContent = this.dataset.index + ' / ' + total;
      });
    });
  }

  function initStickyBar(section) {
    var bar = section.querySelector('[data-th-sticky-bar]');
    var atcBtn = section.querySelector('[data-th-sticky-atc]');
    var mainAtc = section.querySelector('.product-form__submit');
    if (!bar) return;

    bar.setAttribute('aria-hidden', 'false');

    function toggleBar() {
      var show = window.scrollY > 420 && window.innerWidth < 990;
      bar.classList.toggle('is-visible', show);
    }

    if (atcBtn && mainAtc) {
      atcBtn.addEventListener('click', function () {
        mainAtc.click();
      });
    }

    toggleBar();
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
  }

  function initBadgePosition() {
    var bar = document.getElementById('th-badge-rating');
    var section = document.querySelector('product-info.main-product-xc');
    if (!bar || !section) return;

    function moveBar() {
      var gallery =
        section.querySelector('.product__media-wrapper') ||
        section.querySelector('.product__media') ||
        section.querySelector('.product__media-gallery') ||
        section.querySelector('[id^="Slider-Gallery-"]') ||
        section.querySelector('[data-th-fallback-gallery]') ||
        section.querySelector('.product__media-list');
      var titleEl = section.querySelector('.product__title');

      if (window.innerWidth < 750) {
        if (gallery) {
          if (getComputedStyle(gallery).position === 'static') {
            gallery.style.position = 'relative';
          }
          if (bar.parentElement !== gallery) {
            gallery.prepend(bar);
          }
        }
      } else if (titleEl && titleEl.parentElement && titleEl.previousElementSibling !== bar) {
        titleEl.parentElement.insertBefore(bar, titleEl);
      }
    }

    moveBar();
    window.addEventListener('resize', moveBar);
  }

  function initMainProduct(section) {
    if (!section.classList.contains('main-product-xc')) return;

    section.querySelectorAll('[data-th-price-root]').forEach(initPriceBar);
    initFallbackGallery(section);
    initStickyBar(section);
    initBadgePosition();
  }

  function initReviewLink() {
    document.querySelectorAll('[data-th-review-link]').forEach(function (link) {
      if (link.dataset.ready === 'true') return;
      link.dataset.ready = 'true';
      link.addEventListener('click', function (e) {
        var target = document.getElementById('th-anchor-product-reviews-xc');
        if (!target) return;
        e.preventDefault();
        var rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        var offset = 5.6 * rootFont + 24 + 12;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
      });
    });
  }

  function initReviewsVisibility() {
    var section = document.getElementById('th-anchor-product-reviews-xc');
    var widget = section && section.querySelector('.th-reviews__widget');
    if (!section || !widget || section.dataset.visReady === 'true') return;
    section.dataset.visReady = 'true';

    var tab = document.querySelector('.th-pill-nav__item[data-target="th-anchor-product-reviews-xc"]');

    function update() {
      var realCount = widget.querySelectorAll('.jdgm-rev').length;
      var real = realCount > 0;
      var sample = section.querySelector('[data-th-sample-reviews]');
      if (sample) sample.hidden = real;
      var hasContent = real || !!sample || widget.getBoundingClientRect().height > 40;
      section.classList.toggle('is-empty', !hasContent);
      if (tab) tab.hidden = !hasContent;
    }

    update();
    new MutationObserver(update).observe(widget, { childList: true, subtree: true, attributes: true });
    window.addEventListener('load', function () { setTimeout(update, 1500); });
    window.addEventListener('resize', update);
  }

  function initReviewMedia() {
    if (document.documentElement.dataset.thMediaBound === 'true') return;
    document.documentElement.dataset.thMediaBound = 'true';

    var box = null;
    function ensure() {
      if (box) return box;
      box = document.createElement('div');
      box.className = 'th-rv-lightbox';
      box.hidden = true;
      box.innerHTML = '<button type="button" class="th-rv-lightbox__close" aria-label="Close">&times;</button><div class="th-rv-lightbox__box"></div>';
      document.body.appendChild(box);
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target.classList.contains('th-rv-lightbox__close')) close();
      });
      return box;
    }
    function close() {
      if (!box) return;
      box.hidden = true;
      box.querySelector('.th-rv-lightbox__box').innerHTML = '';
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-th-media]');
      if (tile) {
        var b = ensure();
        var holder = b.querySelector('.th-rv-lightbox__box');
        holder.innerHTML = '';
        if (tile.dataset.type === 'video') {
          var v = document.createElement('video');
          v.src = tile.dataset.src;
          v.controls = true;
          v.autoplay = true;
          v.playsInline = true;
          holder.appendChild(v);
        } else {
          var img = document.createElement('img');
          img.src = tile.dataset.src;
          img.alt = '';
          holder.appendChild(img);
        }
        b.hidden = false;
        document.body.style.overflow = 'hidden';
        return;
      }

      var write = e.target.closest('[data-th-write-review]');
      if (write) {
        var link = document.querySelector('.jdgm-write-rev-link');
        if (link && getComputedStyle(link).display !== 'none') {
          link.click();
        } else {
          var note = document.querySelector('[data-th-write-note]');
          if (note) note.hidden = false;
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function initQuantity() {
    document.querySelectorAll('[data-th-qty]').forEach(function (wrap) {
      if (wrap.dataset.qtyReady === 'true') return;
      wrap.dataset.qtyReady = 'true';

      var input = wrap.querySelector('.th-qty__input');
      if (!input) return;

      function clamp(v) {
        v = parseInt(v, 10);
        return isNaN(v) || v < 1 ? 1 : v;
      }

      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-act]');
        if (!btn) return;
        var val = clamp(input.value || 1);
        if (btn.dataset.act === 'inc') val += 1;
        if (btn.dataset.act === 'dec') val = Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', function () {
        input.value = clamp(input.value);
      });
    });
  }

  function initUnderlineHeadings() {
    var titles = Array.prototype.filter.call(
      document.querySelectorAll('.dual-heading__title'),
      function (title) { return !!title.querySelector('.dual-heading__underline'); }
    );

    if (!titles.length) return;

    if (!('IntersectionObserver' in window)) {
      titles.forEach(function (title) {
        title.classList.add('th-underline-visible');
      });
      return;
    }

    titles.forEach(function (title) {
      if (title.dataset.underlineReady === 'true') return;
      title.dataset.underlineReady = 'true';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('th-underline-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });

      observer.observe(title);
    });
  }

  function initProductSections() {
    document.querySelectorAll('product-info.main-product-xc').forEach(initMainProduct);
    document.querySelectorAll('.th-video-reviews').forEach(initCloserVideos);
    initBadgePosition();
    initUnderlineHeadings();
    initQuantity();
    initReviewLink();
    initReviewsVisibility();
    initReviewMedia();
  }

  initProductSections();
  document.addEventListener('shopify:section:load', function () {
    initProductSections();
  });
})();
